const BirthdatePicker = {
  props: {
    value: { default: '' }, //current value
    placeholder: { default: false }, //current value
  },

  data: function () {
    return {
      day: false,
      month: false,
      year: false,
      step: 'closed',
      months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      years: range(16, 70),
    };
  },

  computed: {
    days() {
      if (!this.year || !this.month) return 0;
      const length = new Date(this.year, this.month, 0).getDate();
      return range(1, length);
    },
    monthStart() {
      if (!this.year || !this.month) return 0;
      let gap = new Date(this.year, this.month - 1, 1).getDay();
      const end = new Date(this.year, this.month - 1, 0).getDate();
      gap = (gap + 6) % 7;
      return range(end - gap + 1, end);
    },
    monthEnd() {
      if (!this.year || !this.month) return 0;
      let gap = new Date(this.year, this.month, 0).getDay();
      gap = (gap + 6) % 7;
      return range(1, 7 - gap - 1);
    },
    birthdate() {
      if (!this.year || !this.month || !this.day) {
        return '';
      }
      return [
        this.year,
        (this.month + '').padStart(2, '0'),
        (this.day + '').padStart(2, '0'),
      ].join('-');
    },
  },

  watch: {},

  created() {
    const yy = new Date().getFullYear();
    this.years = this.years.map((y) => yy - y);
  },

  methods: {
    set: function (value) {
      //console.log`('birthday.set', value);
    },
    open: function () {
      //console.log('birthday.open', this.value);
    },
    maybeClose: function () {
      //console.log(this.value, this.value.match(/\d{4}-\d{2}-\d{2}/));
      if (this.step === 'year' && this.value.match(/\d{4}-\d{2}-\d{2}/)) {
        //console.log('Cerramos');
        this.step = 'closed';
      }
    },
    setDay(day) {
      this.day = day;
      this.step = 'closed';
      this.$emit('input', this.birthdate);
      //console.log('birthday.day', day);
    },
    setMonth(month) {
      this.step = 'day';
      this.month = month;
      //console.log('birthday.month', month);
    },
    setYear(year) {
      this.month = this.day = false;
      this.year = year;
      this.step = 'month';
      //console.log('birthday.year', year);
    },
  },

  template: ` 
        <div class="birthdate-picker">
            <input
	            readonly
            	autocomplete="off" 
	            type="text" 
	            class="uk-input"
                :value="value"
                :placeholder="placeholder" 
	            @focus="step = 'year'"
	            @blur="maybeClose(); $emit('blur')"
	            uk-tooltip="Tu fecha de nacimiento no será pública"
            />
			<div class="dropdown-picker" :class="{'-open': step !== 'closed'}">
				<div class="picker -year"  v-if="step == 'year'">
                <strong>Selecciona tu año de nacimiento</strong>
                <ul>
                  <li v-for="year in years" @mousedown="setYear(year)">
                    {{ year }}
                  </li>
                </ul>
              </div>	            
	            <div class="picker -month"  v-if="step == 'month'">
                  <strong>Selecciona tu mes de nacimiento</strong>
	              <ul>
	                  <li v-for="(month,i) in months" @mousedown="setMonth(i+1)">
	                    {{ month }}
	                  </li>
	                </ul>
	            </div>
              	<div class="picker -day" v-if="step == 'day'">
                <strong>Selecciona tu día de nacimiento</strong>
                <ul>
                  <li class="empty" v-for="day in monthStart">{{day}}</li>
                  <li v-for="day in days" @mousedown="setDay(day)">
                    {{ day }}
                  </li>
                  <li class="empty" v-for="day in monthEnd">{{day}}</li>
                </ul>
              </div>
	        </div>
        </div>
    `,
};
